<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs v-model="model" :background-color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'
      ">
      <v-tab :href="`#tab-1`" class="pl-0 ml-0">
        <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
        Live Trades
      </v-tab>
      <v-tab :href="`#tab-2`"> Closed Trades </v-tab>
      <v-tab :href="`#tab-3`"> Short Duration Trades </v-tab>
      <v-tabs-items v-model="model">
        <v-tab-item :value="`tab-1`">
          <v-card flat>
            <LiveTab></LiveTab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-2`">
          <v-card flat>
            <CloseTab></CloseTab>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="`tab-3`">
          <v-card flat>
            <ShortTab></ShortTab>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

import CloseTab from "@/components/Trades/CloseTab.vue";
import LiveTab from "@/components/Trades/LiveTab.vue";
import ShortTab from "@/components/Trades/ShortTab.vue";
export default {
  data() {
    return {
      tab: null,
      model: "tab-1",
    };
  },
  components: {
    LiveTab,
    CloseTab,
    ShortTab
  },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
    hasClosedTradesAccess() {
      return this.loggedAdmin?.roles?.pretty_name === 'super-admin' || this.loggedAdmin?.permissions?.['Trades Section']?.subMenus?.['Closed Trades'] !== 'No Access';
    },
    hasLiveTradesAccess() {
      return this.loggedAdmin?.roles?.pretty_name === 'super-admin' || this.loggedAdmin?.permissions?.['Trades Section']?.subMenus?.['Live Trades'] !== 'No Access';
    },
    hasShortDurationTradesAccess() {
      return this.loggedAdmin?.roles?.pretty_name === 'super-admin' || this.loggedAdmin?.permissions?.['Trades Section']?.subMenus?.['Short Duration Trades'] !== 'No Access';
    },
  },
};
</script>
